export const users = [
  {
    id: 1,
    name: "Test Super Admin",
    email: "admin@truelift.com",
    role: "SUPER_ADMIN",
  },
  {
    id: 2,
    name: "Test Publisher",
    email: "publisher@truelift.com",
    role: "PUBLISHER",
  },
];

export const DEMAND_PARTNER_GAM = "GAM"
export const DEAL_SOURCE_META = "META"


export const publisherDealData = [
  {
    value: "pub1",
    label: "Publisher 1",
    deals: [
      {
        value: "deal1",
        label: "Homepage Display Deal",
      },
      {
        value: "deal2",
        label: "Video Inventory Deal",
      },
      {
        value: "deal3",
        label: "Mobile Banner Deal",
      },
    ],
  },
  {
    value: "pub2",
    label: "Publisher 2",
    deals: [
      {
        value: "deal4",
        label: "CTV Premium Deal",
      },
      {
        value: "deal5",
        label: "Native Ads Deal",
      },
    ],
  },
  {
    value: "pub3",
    label: "Publisher 3",
    deals: [
      {
        value: "deal6",
        label: "Standard Display Deal",
      },
      {
        value: "deal7",
        label: "Interstitial Deal",
      },
    ],
  },
];
